import { DutyScheduleCounselorOptionResponse, DutyScheduleDistributionRowResponse } from "@/api";

export const TOTALS_KEY = "__totals__";

export interface DutyScheduleDistributionRow {
  // The counselor id, or TOTALS_KEY for the totals row.
  key: string;
  userCode: string;
  // null when the roster no longer has an entry for this counselor — rendered by the bare code, the
  // same fallback the counselor filter and the Mitarbeiterübersicht already use.
  counselor: DutyScheduleCounselorOptionResponse | null;
  weeklyHours: number;
  aw12: number;
  aw3: number;
  aw123: number;
  bgs: number;
}

function sortKey(row: DutyScheduleDistributionRow): string {
  return row.counselor == null ? row.userCode : `${row.counselor.lastName}, ${row.counselor.firstName}`;
}

export function buildDistributionRows(
  rows: DutyScheduleDistributionRowResponse[],
  counselors: DutyScheduleCounselorOptionResponse[]
): DutyScheduleDistributionRow[] {
  const counselorById = new Map(counselors.map((counselor) => [counselor.id, counselor]));

  const distributionRows = rows.map((row) => ({
    key: row.counselorId,
    userCode: row.userCode,
    counselor: counselorById.get(row.counselorId) ?? null,
    weeklyHours: row.weeklyHours,
    aw12: row.aw12,
    aw3: row.aw3,
    aw123: row.aw12 + row.aw3,
    bgs: row.bgs,
  }));

  return distributionRows.sort(
    (left, right) => right.weeklyHours - left.weeklyHours || sortKey(left).localeCompare(sortKey(right))
  );
}

export function sumDistributionRows(rows: DutyScheduleDistributionRow[]): DutyScheduleDistributionRow {
  return rows.reduce<DutyScheduleDistributionRow>(
    (sum, row) => ({
      ...sum,
      weeklyHours: sum.weeklyHours + row.weeklyHours,
      aw12: sum.aw12 + row.aw12,
      aw3: sum.aw3 + row.aw3,
      aw123: sum.aw123 + row.aw123,
      bgs: sum.bgs + row.bgs,
    }),
    { key: TOTALS_KEY, userCode: "", counselor: null, weeklyHours: 0, aw12: 0, aw3: 0, aw123: 0, bgs: 0 }
  );
}
